CheckoutV2.PaymentV2.ModalChangeAccount = function(checkout) {
    var changeAccountModal = this;

    this.$modal = $('#changePayPalAccountModal');

    this.currentPayment = null;
    this.shouldOpenAddCardModal = false;

    this.accountChangedCallback = function() {};

    this._init = function() {
        changeAccountModal._listen();
    };

    this._listen = function() {
        // Listener for the change payment submit button.
        changeAccountModal.$modal.find('.js-change-paypal-account-btn').on('click', function(e){
            var $item = changeAccountModal.$modal.find('.js-paypal-account-list input[type=radio]:checked');
            changeAccountModal._getAccounts().forEach(function(account) {
                if(account.id === $item.val()){
                    changeAccountModal.accountChangedCallback(account);
                }
            });
            changeAccountModal.$modal.modal('hide');
        });
    };

    this.render = function() {
        changeAccountModal.$modal.find('.js-paypal-account-list').html(
            Jemplate.process('includes/partials/payment/paypalAccountList.html', {
                current_account: changeAccountModal._getCurrentAccountId(),
                account_list: changeAccountModal._getAccounts(),
                list_type: 'change'
            })
        );
        changeAccountModal.$modal.find('.js-paypal-account-list .account-address[data-toggle="popover"]').popover();
        changeAccountModal.$modal.find('.js-view-payment-method').click( function(e) {
            e.preventDefault();
            var paymentID = $(e.target).data('id');
            var data;
			var paymentInfoURL = checkout.config.siteAbbr == 'ECS' ? '/MyAccount/PaymentInfo/' : '/MyAccount/PaymentInfo';
            var w = window.open( location.origin + paymentInfoURL );
            if (paymentID) {
                data = {
                    action: 'get_payment_url',
                    storedPaymentID: paymentID,
                };      
                var newWindow;
                changeAccountModal.getPaymentPageRequest = $.ajax( {
                    url        : paymentInfoURL,
                    method     : 'POST', 
                    dataType   : 'json', 
                    data       : data, 
                } ).done( function( response ) {
                    if (!response.payment_url) {
                        if (w) w.close();
                        return; 
                    }       
                    if (w) w.location = response.payment_url;
                } ).fail( function() {
                    if (w) w.close();
                    return; 
                } );    
            } else {
                if (w) w.close();
            }
        });     




    };

    this.show = function() {
        changeAccountModal.$modal.modal('show');
    };

    this.hide = function() {
        changeAccountModal.$modal.modal('hide');
    };

    this.setCurrentAccount = function(account) {
		account.id = (account.method.split('-'))[1];
        changeAccountModal.currentPayment = account;
    };

    this.setAccountChangedCallback = function(callback) {
        changeAccountModal.accountChangedCallback = callback;
    };

    this._getCurrentAccountId = function() {
        return changeAccountModal.currentPayment.id;
    };

    this._getAccounts = function() {
        var accounts = [];

        // if ( changeAccountModal.currentPayment ) 
        //    accounts.push( changeAccountModal.currentPayment );
        // Grab stored payments from session
        checkout.session.get('storedPayments').forEach(function(card) {
            if (card.method.match(/creditcard/)) 
                return;
            var payment = checkout.payment.models.paymentMethodFromStoredAccount(card, checkout.cart.totals.values.total);
            var storedPaymentID = ( payment.method.split('-') )[1];
            payment.id = storedPaymentID;
            accounts.push(payment);
        });

        return accounts;
    };

    this._init();
};
